import { IFilter } from '../../types/advancedFilters';
import { SuburbanUtilitiesContainer } from '../../containers/advancedFilters/SuburbanUtilitiesContainer';

export const suburbanUtilities: IFilter = {
  component: SuburbanUtilitiesContainer,
};
